import React, { useMemo } from 'react';
import styled from 'styled-components';

import { FlexRow } from 'components/Shared/Scaffolding';
import { Input, Select } from 'components/Shared/Forms';
import { TextButton } from 'components/Shared/Buttons';
import { Icon, GLYPHS } from 'components/Shared/Icon';
import { SCAFFOLDING, TYPOGRAPHY, SECTIONS } from 'theme';
import { useRecoilValue } from 'recoil';
import { filterOptionsSelector } from 'modules/filter-options';

const opts = (x) => x.map(({ name, value }) => ({ label: name, value }));

const StyledSearchOptions = styled.div`
    margin-left: -${SCAFFOLDING.GUTTER};
    margin-right: -${SCAFFOLDING.GUTTER};
    padding: ${SCAFFOLDING.GUTTER_FACTOR(0.5)} ${SCAFFOLDING.GUTTER};
    background-color: ${SECTIONS.SUB.BG};
`;

const StyledInput = styled(Input)`
    flex: 1 1 auto;

    input {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }
`;

const StyledButton = styled(TextButton)`
    padding-top: 0;
    padding-bottom: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    font-size: ${TYPOGRAPHY.FONT_SIZE.LARGE};
`;

const StyledSelect = styled(Select)`
    flex: 1 1 auto;
    margin-top: ${SCAFFOLDING.GUTTER_FACTOR(0.25)};
`;

const SearchOptions = ({ handleSearchClicked }) => {
    const { sortOptions, tagOptions, colorOptions } = useRecoilValue(filterOptionsSelector);
    const sorts = useMemo(() => opts(sortOptions), [sortOptions]);
    const tags = useMemo(() => opts(tagOptions), [tagOptions]);
    const colors = useMemo(() => opts(colorOptions), [colorOptions]);
    return (
        <StyledSearchOptions>
            <FlexRow spacing={0}>
                <StyledInput name="text" type="text" placeholder="Search..." normalize={(value) => value || null} />
                <StyledButton
                    primary
                    glyph={GLYPHS.SEARCH}
                    onClick={(event) => {
                        event.preventDefault();
                        handleSearchClicked();
                    }}
                >
                    <Icon glyph={GLYPHS.SEARCH} />
                </StyledButton>
            </FlexRow>
            <FlexRow spacing={SCAFFOLDING.GUTTER_FACTOR(0.125)}>
                <StyledSelect
                    name="sort"
                    options={sorts}
                    clearable
                    placeholder="Sort"
                    width={SCAFFOLDING.COLUMN_WIDTH(4)}
                />
                <StyledSelect
                    name="tag"
                    options={tags}
                    clearable
                    placeholder="Tag"
                    width={SCAFFOLDING.COLUMN_WIDTH(4)}
                />
                <StyledSelect
                    name="color"
                    options={colors}
                    clearable
                    placeholder="Color"
                    width={SCAFFOLDING.COLUMN_WIDTH(4)}
                />
            </FlexRow>
        </StyledSearchOptions>
    );
};

export default SearchOptions;
